export default {
  // 字典
  DICTS: {
    COURSE_TYPE: 'zhiya_course_type', // 课程类型
    COURSE_LABEL: 'zhiya_course_label', // 课程标签
  },
  // 课程分类
  ZHIYA_COURSE_TYPE: {
    RESOURCE: 'resource-course', // 资源课程
    VIDEO: 'video-course', // 视频课程
  },
  // 通用状态
  ZHIYA_NORMAL_STATUS: {
    ENABLE: '1', // 启用
    DISABLE: '0', // 禁用
  },
};
